/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import { KeyValue } from '@angular/common';

export type PlcIconSize =
	| 'xs'
	| 's'
	| 'm'
	| 'l'
	| 'xl'
	| 'xxl'
	| 'xxxl'
	| 'masive';

export const PLC_ICON_SIZES: KeyValue<PlcIconSize, string>[] = [
	{ key: 'xs', value: 'Extra Small' },
	{ key: 's', value: 'Small' },
	{ key: 'm', value: 'Medium' },
	{ key: 'l', value: 'Large' },
	{ key: 'xl', value: 'Extra Large' },
	{ key: 'xxl', value: 'Extra Extra Large' },
	{ key: 'xxxl', value: 'Extra Extra Extra Large' },
	{ key: 'masive', value: 'Masive' },
];

export type PlcIconAngle = 90 | 180 | 270;

export const PLC_ICON_ANGLES: KeyValue<PlcIconAngle, string>[] = [
	{ key: 90, value: 'Ninety' },
	{ key: 180, value: 'One Hundred Eighty' },
	{ key: 270, value: 'Two Hundred Seventy' },
];

export type PlcIcon =
	| 'add'
	| 'avatar'
	| 'back'
	| 'bagel'
	| 'battery-3'
	| 'bawl'
	| 'blueberry'
	| 'bounce'
	| 'brain'
	| 'cam'
	| 'clown'
	| 'confetti-2'
	| 'confetti'
	| 'copy'
	| 'cross'
	| 'curved-arrow'
	| 'dot'
	| 'down-arrow'
	| 'email'
	| 'eraser'
	| 'exclamation'
	| 'eye-closed'
	| 'eye'
	| 'filter'
	| 'forward'
	| 'gamepad'
	| 'gear'
	| 'graph'
	| 'headset-mute'
	| 'headset'
	| 'home'
	| 'incongnito'
	| 'info-2'
	| 'info'
	| 'key'
	| 'landscape'
	| 'left-arrow'
	| 'light-bulb'
	| 'link'
	| 'lock'
	| 'logout'
	| 'magnifying-glass'
	| 'maximize'
	| 'menu'
	| 'mic-2'
	| 'mic'
	| 'minimize'
	| 'money-bag'
	| 'moon'
	| 'not-incongnito'
	| 'note'
	| 'orange'
	| 'pause'
	| 'pencil'
	| 'play'
	| 'reddit'
	| 'refresh'
	| 'right-arrow'
	| 'rotate-camera'
	| 'save'
	| 'scale'
	| 'search'
	| 'share'
	| 'skull'
	| 'speaker-high'
	| 'speaker-low'
	| 'speaker-mute'
	| 'speed'
	| 'sun'
	| 'text'
	| 'tick'
	| 'timer'
	| 'trash'
	| 'trophy'
	| 'tv'
	| 'twitter'
	| 'unlock'
	| 'up-arrow'
	| 'upload'
	| 'user-circle'
	| 'user-fill'
	| 'user'
	| 'verified-check'
	| 'wrench'
	| 'youtube';

export const PLC_ICONS: KeyValue<PlcIcon, string>[] = [
	{ key: 'add', value: 'assets/icons/add.svg' },
	{ key: 'avatar', value: 'assets/icons/avatar.svg' },
	{ key: 'back', value: 'assets/icons/back.svg' },
	{ key: 'bagel', value: 'assets/icons/bagel.svg' },
	{ key: 'battery-3', value: 'assets/icons/battery-3.svg' },
	{ key: 'bawl', value: 'assets/icons/bawl.svg' },
	{ key: 'blueberry', value: 'assets/icons/blueberry.svg' },
	{ key: 'bounce', value: 'assets/icons/bounce.svg' },
	{ key: 'brain', value: 'assets/icons/brain.svg' },
	{ key: 'cam', value: 'assets/icons/cam.svg' },
	{ key: 'clown', value: 'assets/icons/clown.svg' },
	{ key: 'confetti-2', value: 'assets/icons/confetti-2.svg' },
	{ key: 'confetti', value: 'assets/icons/confetti.svg' },
	{ key: 'copy', value: 'assets/icons/copy.svg' },
	{ key: 'cross', value: 'assets/icons/cross.svg' },
	{ key: 'curved-arrow', value: 'assets/icons/curved-arrow.svg' },
	{ key: 'dot', value: 'assets/icons/dot.svg' },
	{ key: 'down-arrow', value: 'assets/icons/down-arrow.svg' },
	{ key: 'email', value: 'assets/icons/email.svg' },
	{ key: 'eraser', value: 'assets/icons/eraser.svg' },
	{ key: 'exclamation', value: 'assets/icons/exclamation.svg' },
	{ key: 'eye-closed', value: 'assets/icons/eye-closed.svg' },
	{ key: 'eye', value: 'assets/icons/eye.svg' },
	{ key: 'filter', value: 'assets/icons/filter.svg' },
	{ key: 'forward', value: 'assets/icons/forward.svg' },
	{ key: 'gamepad', value: 'assets/icons/gamepad.svg' },
	{ key: 'gear', value: 'assets/icons/gear.svg' },
	{ key: 'graph', value: 'assets/icons/graph.svg' },
	{ key: 'headset-mute', value: 'assets/icons/headset-mute.svg' },
	{ key: 'headset', value: 'assets/icons/headset.svg' },
	{ key: 'home', value: 'assets/icons/home.svg' },
	{ key: 'incongnito', value: 'assets/icons/incongnito.svg' },
	{ key: 'info-2', value: 'assets/icons/info-2.svg' },
	{ key: 'info', value: 'assets/icons/info.svg' },
	{ key: 'key', value: 'assets/icons/key.svg' },
	{ key: 'landscape', value: 'assets/icons/landscape.svg' },
	{ key: 'left-arrow', value: 'assets/icons/left-arrow.svg' },
	{ key: 'light-bulb', value: 'assets/icons/light-bulb.svg' },
	{ key: 'link', value: 'assets/icons/link.svg' },
	{ key: 'lock', value: 'assets/icons/lock.svg' },
	{ key: 'logout', value: 'assets/icons/logout.svg' },
	{ key: 'magnifying-glass', value: 'assets/icons/magnifying-glass.svg' },
	{ key: 'maximize', value: 'assets/icons/maximize.svg' },
	{ key: 'menu', value: 'assets/icons/menu.svg' },
	{ key: 'mic-2', value: 'assets/icons/mic-2.svg' },
	{ key: 'mic', value: 'assets/icons/mic.svg' },
	{ key: 'minimize', value: 'assets/icons/minimize.svg' },
	{ key: 'money-bag', value: 'assets/icons/money-bag.svg' },
	{ key: 'moon', value: 'assets/icons/moon.svg' },
	{ key: 'not-incongnito', value: 'assets/icons/not-incongnito.svg' },
	{ key: 'note', value: 'assets/icons/note.svg' },
	{ key: 'orange', value: 'assets/icons/orange.svg' },
	{ key: 'pause', value: 'assets/icons/pause.svg' },
	{ key: 'pencil', value: 'assets/icons/pencil.svg' },
	{ key: 'play', value: 'assets/icons/play.svg' },
	{ key: 'reddit', value: 'assets/icons/reddit.svg' },
	{ key: 'refresh', value: 'assets/icons/refresh.svg' },
	{ key: 'right-arrow', value: 'assets/icons/right-arrow.svg' },
	{ key: 'rotate-camera', value: 'assets/icons/rotate-camera.svg' },
	{ key: 'save', value: 'assets/icons/save.svg' },
	{ key: 'scale', value: 'assets/icons/scale.svg' },
	{ key: 'search', value: 'assets/icons/search.svg' },
	{ key: 'share', value: 'assets/icons/share.svg' },
	{ key: 'skull', value: 'assets/icons/skull.svg' },
	{ key: 'speaker-high', value: 'assets/icons/speaker-high.svg' },
	{ key: 'speaker-low', value: 'assets/icons/speaker-low.svg' },
	{ key: 'speaker-mute', value: 'assets/icons/speaker-mute.svg' },
	{ key: 'speed', value: 'assets/icons/speed.svg' },
	{ key: 'sun', value: 'assets/icons/sun.svg' },
	{ key: 'text', value: 'assets/icons/text.svg' },
	{ key: 'tick', value: 'assets/icons/tick.svg' },
	{ key: 'timer', value: 'assets/icons/timer.svg' },
	{ key: 'trash', value: 'assets/icons/trash.svg' },
	{ key: 'trophy', value: 'assets/icons/trophy.svg' },
	{ key: 'tv', value: 'assets/icons/tv.svg' },
	{ key: 'twitter', value: 'assets/icons/twitter.svg' },
	{ key: 'unlock', value: 'assets/icons/unlock.svg' },
	{ key: 'up-arrow', value: 'assets/icons/up-arrow.svg' },
	{ key: 'upload', value: 'assets/icons/upload.svg' },
	{ key: 'user-circle', value: 'assets/icons/user-circle.svg' },
	{ key: 'user-fill', value: 'assets/icons/user-fill.svg' },
	{ key: 'user', value: 'assets/icons/user.svg' },
	{ key: 'verified-check', value: 'assets/icons/verified-check.svg' },
	{ key: 'wrench', value: 'assets/icons/wrench.svg' },
	{ key: 'youtube', value: 'assets/icons/youtube.svg' },
];
